import smartDate from "@qrohlf/smart-date";
import { NoticeBar } from "common/styleguide/NoticeBar";
import { capitalize } from "lib/utils";
import moment from "moment";
import React from "react";
import styles from "./TrialNoticeBar.scss";

const TRIAL_NOTICE_PREF = "show_dash_trial_notice";
const EXPIRING_TRIAL_NOTICE_PREF = "show_dash_expiring_trial_notice";

export class TrialNoticeBar extends React.PureComponent {
  dismissTrialNotice = () => {
    const { currentUser, setPreference, clearTrialBanner } = this.props;
    if (this.trialExpiresSoon()) {
      setPreference(EXPIRING_TRIAL_NOTICE_PREF, false);
    }
    setPreference(TRIAL_NOTICE_PREF, false);
    clearTrialBanner(currentUser.id);
  };

  trialExpiresSoon = () => {
    const { currentUser } = this.props;
    return moment(currentUser.trialEndDate).isBetween(moment(), moment().add(1, "week"));
  };

  render() {
    const {
      currentUser: { inActiveTrial, trialShowBanner, preferences, accountLevel, trialEndDate },
    } = this.props;

    const showTrialNoticeBar =
      inActiveTrial &&
      trialShowBanner &&
      (preferences.get(TRIAL_NOTICE_PREF, true) ||
        (this.trialExpiresSoon() && preferences.get(EXPIRING_TRIAL_NOTICE_PREF, true)));

    if (!showTrialNoticeBar) {
      return null;
    }

    const accountLevelStringLower = accountLevel === 2 ? "premium" : "basic";
    const accountLevelString = capitalize(accountLevelStringLower);

    return (
      <NoticeBar className={styles.TrialNoticeBar} onRequestClose={this.dismissTrialNotice}>
        {this.trialExpiresSoon()
          ? `Your trial of Ride with GPS ${accountLevelString} ends on ${smartDate(trialEndDate, {
              includeTime: false,
              includeYear: true,
            })}. Want to keep it going? `
          : `Your account is currently on a ${accountLevelString} trial through ${smartDate(trialEndDate, {
              includeTime: false,
              includeYear: true,
            })}. `}
        <a className={styles.orange} href={`/subscriptions/new?account_level=${accountLevelStringLower}`}>
          Upgrade your account
        </a>
      </NoticeBar>
    );
  }
}
